var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgImageMedium(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 48 48",
    style: {
      enableBackground: "new 0 0 48 48"
    },
    xmlSpace: "preserve",
    fill: "currentColor",
    stroke: "currentColor",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M39,4H9C6.2431641,4,4,6.2431641,4,9v30c0,2.7568359,2.2431641,5,5,5h30c2.7568359,0,5-2.2431641,5-5V9 C44,6.2431641,41.7568359,4,39,4z M9,6h30c1.6542969,0,3,1.3457031,3,3v15.5859375l-4.8789062-4.8789062 C36.0361328,18.6220703,34.5341797,18,33,18s-3.0361328,0.6220703-4.1210938,1.7070312L19,29.5859375l-1.8789062-1.8789062 C16.0361328,26.6220703,14.5341797,26,13,26s-3.0361328,0.6220703-4.1210938,1.7070312L6,30.5859375V9C6,7.3457031,7.3457031,6,9,6 z M39,42H9c-1.6542969,0-3-1.3457031-3-3v-5.5859375l4.2929688-4.2929688C11.0058594,28.4082031,11.9921875,28,13,28 s1.9941406,0.4082031,2.7070312,1.1210938l2.5859375,2.5859375c0.390625,0.390625,1.0234375,0.390625,1.4140625,0 l10.5859375-10.5859375C31.0058594,20.4082031,31.9921875,20,33,20s1.9941406,0.4082031,2.7070312,1.1210938L42,27.4140625V39 C42,40.6542969,40.6542969,42,39,42z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15,20c2.7568359,0,5-2.2431641,5-5s-2.2431641-5-5-5s-5,2.2431641-5,5S12.2431641,20,15,20z M15,12 c1.6542969,0,3,1.3457031,3,3s-1.3457031,3-3,3s-3-1.3457031-3-3S13.3457031,12,15,12z"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgImageMedium);
export default __webpack_public_path__ + "static/media/image--medium.e2ba9b2fa823071ae08cd35b48899a07.svg";
export { ForwardRef as ReactComponent };